import axios from "axios";

import API_URLS from "constants/apis.url";
import { AXIOS_TIMEOUT } from "constants/globalConstants";

const { origin, hostname } = window.location;
const isLocalHost = hostname === "localhost";
const SERVER_BASE_URL = isLocalHost ? process.env.REACT_APP_BASE_URL_DEV : origin;

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}${API_URLS.apiVersion}`,
  timeout: AXIOS_TIMEOUT
});

export const AxiosInstanceWithoutTimeout = axios.create({ baseURL: `${SERVER_BASE_URL}${API_URLS.apiVersion}` });

export default AxiosInstance;
